module.exports = __webpack_public_path__ + "media/images/menu/gemini-d4e8f441881b5a1f28aef84444fe6dd5.jpg";